export const DATA_TEST_IDS = {
  translateLanguageSelect: 'multilanguage-modal-translate-language-select',
  translateButton: 'multilanguage-modal-translate-button',
};
